import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import {
  AddDeliveryManagerRequestSchema,
  DeleteSubAdminsRequest,
  EditDeliveryManagerRequestSchema,
  ToggleSubAdminStatusRequest,
} from '.././client-sdk/api';

export const useDeliveryManagerApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createDeliveryManager = useCallback(
    async (deliveryManagerData: AddDeliveryManagerRequestSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.addDeliveryManager(deliveryManagerData);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getAllDeliveryManager = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        // Only include search parameter if it has a value
        const searchParam =
          query.search && query.search.trim() !== '' ? query.search : undefined;
        const response = await api.getAllDeliveryManagers(
          query.page,
          query.limit,
          query.sortBy,
          query.sortOrder,
          searchParam
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getToggleStatus = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest = {
          ids: Array.isArray(query.id) ? query.id : [query.id],
          status: query.status,
        };
        const response = await api.toggleDeliveryManagerStatus(
          toggleSubAdminStatusRequest
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const deleteDeliveryManager = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const deleteSubAdmins: DeleteSubAdminsRequest = {
          ids: query,
        };
        const response = await api.deleteDeliveryManagers(deleteSubAdmins);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const editDeliveryManager = useCallback(
    async (id: any, subAdminData: EditDeliveryManagerRequestSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.editDeliveryManager(id, subAdminData);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );
  return {
    createDeliveryManager,
    getAllDeliveryManager,
    loading,
    error,
    getToggleStatus,
    deleteDeliveryManager,
    editDeliveryManager,
  };
};
